<template>
    <div class="find-picture-box">
        <div class="time">
            <div class="time-left">
                <el-select
                    popper-class="boss"
                    style="vertical-align: bottom; margin-right: 20px"
                   :placeholder="$t('chengguan.dailypatrol.pleaseSelectData')"
                    v-model="LImgId"
                >
                    <el-option
                        v-for="(item, index) in historyImgListL"
                        :key="item.id + '-' + index"
                        :label="item.createTime || item.eventTime"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="time-right">
                <el-select
                    popper-class="boss"
                    style="vertical-align: bottom; margin-right: 20px"
                    :placeholder="$t('chengguan.dailypatrol.pleaseSelectData')"
                    v-model="RImgId"
                >
                    <el-option
                        v-for="(item, index) in historyImgListR"
                        :key="item.id + '-' + index"
                        :label="item.createTime || item.eventTime"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="history-content" @mouseleave="MouseleaveH">
            <div
                ref="imageBox"
                class="history-content-l"
                :class="cursorStatus ? 'zhua' : 'mo'"
                style=""
                @mouseleave="MouseleaveH"
                @mousewheel="zoomImgH"
                @mouseenter="initDragH"
            >
                <img
                    ref="img1"
                    data-id="1"
                    class="contrast-img"
                    :src="curPicL.filePathUrl || curPicL.pathsUrl"
                />
            </div>
            <div
                ref="imageBox2"
                class="history-content-r"
                :class="cursorStatus ? 'zhua' : 'mo'"
                @mouseleave="MouseleaveH"
                @mousewheel="zoomImgH"
                @mouseenter="initDragH"
            >
                <img
                    ref="img2"
                    class="contrast-img"
                    data-id="2"
                    :src="curPicR.filePathUrl || curPicR.pathsUrl"
                />
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        historyImgList: Array,
        imgModel: String,
    },

    data() {
        return {
            showDialog: true,
            active: false,
            LImgId: '',
            RImgId: '',
            curPicL: {},
            curPicR: {},
            historyImgListL: [], // 左列表图
            historyImgListR: [], // 左列表图
            value1: null,
            zoomParams: {
                zoomVal: 1,
                left: 0,
                top: 0,
                currentX: 0,
                currentY: 0,
                flag: false,
            },
        };
    },
    computed: {
        // 手势
        cursorStatus() {
            return this.zoomParams.flag;
        },
    },
    watch: {
        LImgId: {
            deep: true,
            async handler(newVal) {
                let imgObj = this.historyImgListL.find((item) => item.id === newVal);
                if (!imgObj) return;
                this.curPicL = imgObj;
            },
        },
        RImgId: {
            deep: true,
            async handler(newVal) {
                let imgObj = this.historyImgListL.find((item) => item.id === newVal);
                if (!imgObj) return;
                this.curPicR = imgObj;
            },
        },
        historyImgList: {
            immediate: true,
            handler(newVal) {
                this.curPicL = newVal[0] || {};
                this.curPicR = newVal[1] || {};
                this.LImgId = newVal[0]?.id;
                this.RImgId = newVal[1]?.id;
                this.historyImgListL = newVal;
                this.historyImgListR = newVal;
            },
        },
    },
    mounted() {},

    methods: {
        initDragH() {
            const self = this;
            // 获取相关CSS属性
            let getCss = function (o, key) {
                return o.currentStyle
                    ? o.currentStyle[key]
                    : document.defaultView.getComputedStyle(o, false)[key];
            };
            // 拖拽的实现
            let target = this.$refs.img1;
            let target2 = this.$refs.img2;
            if (getCss(target, 'left') !== 'auto') {
                self.zoomParams.left = getCss(target, 'left');
            }
            if (getCss(target, 'top') !== 'auto') {
                self.zoomParams.top = getCss(target, 'top');
            }
            // o是移动对象
            let onmousedown = function (event) {
                if (event.target.dataset.id === '1') {
                    // 左
                    self.getOffset(self.$refs.imageBox);
                }
                if (event.target.dataset.id === '2') {
                    // 右
                    self.getOffset(self.$refs.imageBox2);
                }

                self.zoomParams.flag = true;
                if (!event) {
                    event = window.event;
                    // 防止IE文字选中
                    target.onselectstart = function () {
                        return false;
                    };
                    target2.onselectstart = function () {
                        return false;
                    };
                }
                let e = event;
                self.zoomParams.currentX = e.clientX;
                self.zoomParams.currentY = e.clientY;
            };
            target.onmousedown = onmousedown;
            target2.onmousedown = onmousedown;
            document.onmouseup = function () {
                self.zoomParams.flag = false;

                if (getCss(target, 'left') !== 'auto') {
                    self.zoomParams.left = getCss(target, 'left');
                }
                if (getCss(target, 'top') !== 'auto') {
                    self.zoomParams.top = getCss(target, 'top');
                }
            };
            document.onmousemove = function (event) {
                if (this.showBtn) return;
                let e = event || window.event;
                if (self.zoomParams.flag) {
                    let nowX = e.clientX;
                    let nowY = e.clientY;
                    let disX = nowX - self.zoomParams.currentX;
                    let disY = nowY - self.zoomParams.currentY;
                    self.moveLeft += disX;
                    // eslint-disable-next-line radix
                    let left = `${parseInt(self.zoomParams.left) + disX}px`;
                    // eslint-disable-next-line radix
                    let top = `${parseInt(self.zoomParams.top) + disY}px`;
                    target.style.left = left;
                    target.style.top = top;
                    target2.style.left = left;
                    target2.style.top = top;
                    if (event.preventDefault) {
                        event.preventDefault();
                    }
                }
            };
        },
        getOffset(obj) {
            let left = obj.offsetLeft;
            let top = obj.offsetTop;
            let val = obj.offsetParent;
            while (val != null) {
                top += val.offsetTop;
                left += val.offsetLeft;
                val = val.offsetParent;
            }
            let bottom = obj.offsetHeight + top;
            let right = obj.offsetWidth + left;
            this.offset = {
                left,
                right,
                top,
                bottom,
            };
            return { left, top };
        },
        zoomImgH(event) {
            let target = this.$refs.img1;
            let target2 = this.$refs.img2;
            this.zoomParams.zoomVal += event.wheelDelta / 1200;
            if (this.zoomParams.zoomVal >= 0.2) {
                target.style.transform = `scale(${this.zoomParams.zoomVal})`;
                target2.style.transform = `scale(${this.zoomParams.zoomVal})`;
            } else {
                this.zoomParams.zoomVal = 0.2;
                target.style.transform = `scale(${this.zoomParams.zoomVal})`;
                target2.style.transform = `scale(${this.zoomParams.zoomVal})`;
            }
        },
        MouseleaveH(e) {
            document.onmousemove = null;
            this.zoomParams.flag = false;
        },
        mousemoveFn(e) {
            if (!this.active) return;
            let x = e.pageX;
            x -= this.wrapper.getBoundingClientRect().left;
            this.scrollIt(x);
        },
        scrollIt(x) {
            let transform = Math.max(0, Math.min(x, this.wrapper.offsetWidth));
            this.after.style.width = `${transform}px`;
            this.scroller.style.left = `${transform - 25}px`;
        },
    },
};
</script>

<style lang="scss" scoped>
* {
    margin: 0;
    box-sizing: border-box;
}
.find-picture-box {
    width: 100%;
    height: 100%;
    ::v-deep .el-input__inner {
        background-color: #112d7b;
        border-color: #1a47a4;
        color: #fff;
    }

    .time {
        position: absolute;
        left: 8px;
        width: 100%;
        top: 19px;
        display: flex;
        line-height: 58px;
        justify-content: space-around;
        margin: 10px 0;
        // background: rgba(7, 17, 80, 0.6);
        z-index: 999;
    }
    .dialog-img-title {
        text-align: center;
        position: relative;
        display: flex;

        width: 100%;
        line-height: 28px;
        .title-txt {
            width: 100%;
        }
        .icon-close {
            position: absolute;
            right: -40px;
            top: -40px;
            width: 41px;
            height: 41px;
        }
    }
}
.history-content {
    display: flex;
    justify-content: space-around;
    width: 100%;
    height: calc(100% - 0px);
    .contrast-img {
        width: 100%;
        position: absolute;
        left: 0;
        right: 0;
        height: 100%;
        object-fit: contain;
    }
    .history-content-l {
        width: 50%;
        height: 100%;
        overflow: hidden;
        position: relative;
        margin-right: 8px;
        background: #1f2e43;
        // border-right: 1px solid #1d4394ff;
    }
    .history-content-r {
        width: 50%;
        height: 100%;
        overflow: hidden;
        position: relative;
        background: #1f2e43;
    }
}
#page {
    width: 94%;
    height: calc(100% - 70px);
    position: absolute;
    margin-left: 50px;
}

.wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}

.before,
.after {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    overflow: hidden;
}

.content-image {
    height: 100%;
}

.after {
    width: 125px;
}

.scroller {
    width: 50px;
    height: 50px;
    position: absolute;
    left: 100px;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 50%;
    background-color: transparent;
    opacity: 0.9;
    pointer-events: auto;
    cursor: pointer;
}

.scroller:hover {
    opacity: 1;
}

.scrolling {
    pointer-events: none;
    opacity: 1;
    z-index: 1;
}

.scroller__thumb {
    width: 100%;
    height: 100%;
    padding: 5px;
}

.scroller:before,
.scroller:after {
    content: ' ';
    display: block;
    width: 7px;
    height: 9999px;
    position: absolute;
    left: 50%;
    margin-left: -3.5px;
    z-index: 30;
    transition: 0.1s;
}

.scroller:before {
    top: 100%;
}

.scroller:after {
    bottom: 100%;
}

.scroller {
    border: 5px solid #fff;
}

.scroller:before,
.scroller:after {
    background: #fff;
}
.mo {
    cursor: grab;
}

.zhua {
    cursor: grabbing;
}
</style>
